import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";
import {setLocalStorage, getLocalStorage, checkDocument} from "@js/helpers.ts";
import {useMenuStore} from "@js/store/MenuStore.js";
import axios from 'axios';

const getCompareIdsFromCookie = () => {
    if (!checkDocument()) return [];

    const compares = getLocalStorage('comparedIds');

    if (compares) {
        try {
            return JSON.parse(compares);
        } catch (e) {
            console.error('Не удалось распарсить comparedIds из localStorage', e);
            return [];
        }
    }

    return [];
};

export const useCompareStore = defineStore('compareStore', {
    state: () => ({
        comparedIds: getCompareIdsFromCookie(),
        comparing_data: {characteristics: {}, data: {}},
        loading_products: false,
    }),

    actions: {
        getCompares() {
            if (!checkDocument()) return [];

            const compares = getLocalStorage('comparedIds');

            if (compares) {
                try {
                    this.comparedIds = JSON.parse(compares);
                } catch (e) {
                    console.error('Не удалось распарсить comparedIds из localStorage', e);
                    this.comparedIds = [];
                }
            } else {
                this.comparedIds = [];
            }

            return this.comparedIds;
        },

        toggleCompare(productId) {
            const themeStore = useThemeStore();

            if (this.isCompared(productId)) {
                this.comparedIds = this.comparedIds.filter(id => id !== productId);
                themeStore.addToast("Убрано из сравнения", "success");
            } else {
                this.comparedIds.push(productId);
                themeStore.addToast("Добавлено к сравнению", "success", {
                    route_name: 'compareProducts',
                }, 5000);

                const menuStore = useMenuStore();
                menuStore.triggerCatalogButtonPing?.('bg-blue-500');
            }

            setLocalStorage('comparedIds', JSON.stringify(this.comparedIds), 525600);
        },

        isCompared(productId) {
            return this.comparedIds.includes(productId);
        },

        getComparedProductsData() {
            if (!this.comparedIds.length) {
                this.comparing_data = {characteristics: {}, data: {}};
                this.loading_products = false;
                return;
            }

            this.loading_products = true;

            axios.post('/axios/products/get-comparison-data', {
                ids: this.comparedIds,
            })
                .then(response => {
                    this.comparing_data = response.data ?? {characteristics: {}, data: {}};
                })
                .catch((error) => {
                    console.error('Ошибка загрузки данных сравнения', error);
                    this.comparing_data = {characteristics: {}, data: {}};
                })
                .finally(() => {
                    this.loading_products = false;
                });
        },
    },
});
